import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from 'antd';
import styles from './filters.module.css';
import FilterElementWrap from '../../../components/Filters/filterElementWrap';

const NameFilter = ({
  onChange,
  disabled,
}: {
  onChange: (value: string | undefined) => void;
  disabled?: boolean;
}): ReactElement => {
  const { t } = useTranslation('common');

  const handleSearch = async (event: React.FormEvent<HTMLInputElement>): Promise<void> => {
    const companyName = event.currentTarget?.value ?? undefined;
    onChange(companyName);
  };

  return (
    <FilterElementWrap>
      <Input
        onChange={handleSearch}
        placeholder={t('misc.searchByCompanyName') ?? ''}
        className={styles.fullWidth}
        disabled={disabled}
      />
    </FilterElementWrap>
  );
};

export default NameFilter;
